import * as React from "react";
const SiteLogo = (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" {...props}>
        <path
            fill="#EF002A"
            d="M28 0H4C1.79 0 0 1.781 0 3.99v24.017C0 30.216 1.79 32 4 32h24c2.21 0 4-1.784 4-3.993V3.99C32 1.781 30.21 0 28 0Z"
        />
        <path
            fill="#fff"
            fillRule="evenodd"
            d="M16.985 9.149c-.502.004-1.003.365-1.003 1.074v7.42c0 1.078-1.39.99-1.39 0v-7.42c0-1.418-2.01-1.418-2.01 0v7.48c0 1.71 1.225 2.848 2.687 2.848 1.5 0 2.721-1.137 2.721-2.848v-7.48c0-.723-.503-1.077-1.005-1.074Zm5.064-.005c-.408 0-.716.282-.87.621L18.946 13.6c-.155.355-.268.754-.268 1.017 0 .236.03.444.113.636l2.416 6.02h-9.38c-.338 0-.617-.353-.617-.68v-10.37c-.07-1.418-2.024-1.399-2.067.063l.042 10.987c0 1.197.887 2.155 2.025 2.155H24l-3.118-8.32c-.086-.31-.124-.591.086-.96l2.062-3.5a2.43 2.43 0 0 0 .072-.47c-.041-.635-.519-1.062-1.053-1.034Z"
            clipRule="evenodd"
        />
    </svg>
);
export default SiteLogo;
